export const dateTimeFormat = {
	timeZone: 'America/New_York',
	locale: 'en-US',
};
